import React from 'react'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { authApi } from 'api/auth'
import { appActions } from 'store/app'
import { bodyScrollLock } from 'shared/utils/bodyScrollLock'
import { showServerError } from 'shared/utils/showServerError'
import { useAppDispatch } from './useReduxHooks'

// Выход из аккаунта с подтверждением — вызывается из разных меню
export const useLogoutConfirm = () => {
  const dispatch = useAppDispatch()

  return React.useCallback(() => {
    const logout = async () => {
      try {
        await authApi.logout()
        dispatch(appActions.logout())
      } catch (e) {
        showServerError(e)
      } finally {
        bodyScrollLock.disable()
      }
    }

    bodyScrollLock.enable()
    Modal.confirm({
      centered: true,
      title: 'Вы действительно хотите выйти из аккаунта?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Выйти',
      cancelText: 'Закрыть',
      onOk() {
        return new Promise((resolve) => {
          logout().then(resolve)
        })
      },
      onCancel() {
        bodyScrollLock.disable()
      }
    })
  }, [dispatch])
}
